import { render, staticRenderFns } from "./Adviser.vue?vue&type=template&id=3921a848&scoped=true"
import script from "./Adviser.vue?vue&type=script&lang=js"
export * from "./Adviser.vue?vue&type=script&lang=js"
import style0 from "./Adviser.vue?vue&type=style&index=0&id=3921a848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3921a848",
  null
  
)

export default component.exports